module.exports = __webpack_public_path__ + "static/assets/img/videoconference.8a1fddc6.png";